"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ComboBox.css");
var icons = require("./../../../styles/att-icons.css");
var utils_1 = require("../../../utils/utils");
var key_press_1 = require("../../../utils/key-press");
var TextField_1 = require("../TextField");
var TextFieldProps_1 = require("../TextField/TextFieldProps");
var ComboOption_1 = require("./components/ComboOption/ComboOption");
var optionStyles = require("./components/ComboOption/ComboOption.css");
var textFieldStyles = require("../TextField/TextField.css");
var lodash_1 = require("lodash");
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var upArrowIsPressed = key_press_1.KeyPress.upArrowIsPressed;
var downArrowIsPressed = key_press_1.KeyPress.downArrowIsPressed;
var tabIsPressed = key_press_1.KeyPress.tabIsPressed;
var ComboBox = /** @class */ (function (_super) {
    __extends(ComboBox, _super);
    function ComboBox(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelect = _this.onSelect.bind(_this);
        _this.onNoSuggestionSelect = _this.onNoSuggestionSelect.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onClear = _this.onClear.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.filterAndSetData = _this.filterAndSetData.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleArrowBtnClick = _this.handleArrowBtnClick.bind(_this);
        _this.props.options.dataSearch = _this.props.options.dataSearch === false ? false : true;
        _this.state = {
            currentData: props.data,
            currentText: props.data.value || null,
            currentValue: null,
            isOpen: false,
        };
        return _this;
    }
    ComboBox.prototype.componentDidUpdate = function () {
        if (this.state.isOpen) {
            window.document.addEventListener('click', this.onDocumentClick);
            return;
        }
        this.clearOutsideHandler();
    };
    ComboBox.prototype.componentWillUnmount = function () {
        this.clearOutsideHandler();
    };
    ComboBox.prototype.componentWillReceiveProps = function (newProps) {
        if (!lodash_1.isEqual(newProps.data, this.props.data)) {
            this.setState(function () { return ({
                currentData: (newProps.data || null),
                currentText: (newProps.data.value || null),
            }); });
        }
    };
    ComboBox.prototype.clearOutsideHandler = function () {
        document.removeEventListener('click', this.onDocumentClick);
    };
    ComboBox.prototype.onDocumentClick = function (e) {
        this.onClick(e);
    };
    ComboBox.prototype.onSelect = function (choice, enter) {
        var _this = this;
        this.setState({ currentText: choice.displayText, currentValue: choice,
            isOpen: false }, function () {
            if (_this.props.events && _this.props.events.onSelect) {
                _this.props.events.onSelect(_this.state.currentValue);
            }
        });
    };
    ComboBox.prototype.onNoSuggestionSelect = function () {
        this.setState({ isOpen: false });
    };
    ComboBox.prototype.onClear = function (value) {
        this.setState({
            currentData: this.props.data,
            currentText: '',
            isOpen: !this.props.options.dataSearch ? false : true,
        });
        if (this.props.events && this.props.events.onClear) {
            this.props.events.onClear(value);
        }
    };
    ComboBox.prototype.onKeyUp = function (currentValue, e) {
        e.preventDefault();
        if (enterIsPressed(e)) {
            this.setState(function (prevState) { return ({
                isOpen: !prevState.isOpen,
            }); });
        }
        else if (this.state.isOpen && downArrowIsPressed(e)) {
            var comoboboxElement = e.currentTarget.parentElement.parentElement.parentElement;
            var liElement = comoboboxElement.querySelector('.' + optionStyles.menuItemSelected + ':focus');
            if (liElement) {
                liElement.nextElementSibling.focus();
            }
            else {
                liElement = comoboboxElement.querySelector('.' + optionStyles.menuItem);
                liElement.focus();
            }
        }
        else {
            var textFieldValue = e.currentTarget.value;
            this.filterAndSetData(textFieldValue, true);
            if (this.props.events && this.props.events.onChange) {
                this.props.events.onChange(textFieldValue);
            }
        }
        if (this.props.events && this.props.events.onKeyPress) {
            this.props.events.onKeyPress(e.currentTarget.value, e);
        }
    };
    ComboBox.prototype.onClick = function (e) {
        e.stopPropagation();
        this.filterAndSetData(this.state.currentText, !this.state.isOpen);
    };
    ComboBox.prototype.onFocus = function (e) {
        e.stopPropagation();
        // console.log(' getting combobox focus ');
        // this.filterAndSetData(this.state.currentText, !this.state.isOpen);
    };
    ComboBox.prototype.onBlur = function (value) {
        if (this.props.events && this.props.events.onBlur) {
            this.props.events.onBlur(value);
        }
    };
    ComboBox.prototype.handleKeyDown = function (e) {
        var _this = this;
        var _a;
        e.preventDefault();
        e.stopPropagation();
        // console.log('e.currentTarget' + e.currentTarget);
        var comoboboxElement = e.currentTarget.parentElement.parentElement.parentElement;
        var liElement = comoboboxElement.querySelector('.' + optionStyles.menuItem + ':focus');
        var textFieldElement = comoboboxElement.querySelector('.' + textFieldStyles.textField);
        if (this.state.isOpen && tabIsPressed(e)) {
            e.stopPropagation();
            (_a = comoboboxElement.querySelector('input')) === null || _a === void 0 ? void 0 : _a.focus();
            setTimeout(function () {
                _this.setState(function (prevState) { return ({
                    isOpen: !prevState.isOpen,
                }); });
            }, 300);
            return;
        }
        if (this.state.isOpen && downArrowIsPressed(e)) {
            // console.log('ComboBox handleKeyDown down executed ' + liElement);
            if (liElement) {
                liElement.nextElementSibling ? liElement.nextElementSibling.focus() : textFieldElement.focus();
            }
            else {
                liElement = comoboboxElement.querySelector('.' + optionStyles.menuItem);
                liElement.focus();
            }
        }
        else if (this.state.isOpen && upArrowIsPressed(e)) {
            // console.log('ComboBox handleKeyDown up executed ' + liElement);
            if (liElement) {
                liElement.previousElementSibling ? liElement.previousElementSibling.focus() : textFieldElement.focus();
            }
            else {
                liElement = comoboboxElement.querySelector('.' + optionStyles.menuItem);
                liElement.focus();
            }
        }
    };
    ComboBox.prototype.handleArrowBtnClick = function (e) {
        e.preventDefault();
        try {
            var textFieldContainer = e.currentTarget.parentElement;
            var inputElement = textFieldContainer.getElementsByTagName('input')[0];
            /// Commenting since clicking on the button should not focus on the textbox//
            //inputElement.focus();
        }
        catch (e) {
            //
        }
    };
    ComboBox.prototype.render = function () {
        var _this = this;
        // console.log('executing render');
        var isRedesign = this.props.options && this.props.options.isRedesign;
        var isRennyStyle = this.props.options && this.props.options.isRennyStyle;
        var isOpen = this.state.isOpen;
        var choices = this.state.currentData.choices;
        var labelProp = this.props.options && this.props.options.label ? this.props.options.label : false;
        var wrapperCls = [styles.container, this.props.options.className].join(' ');
        var containerCls = isOpen ? [styles.comboboxContainer, styles.comboboxOpen].join(' ') : styles.comboboxContainer;
        var dropdownClsPicker = isRedesign ? styles.dropdownRedesign : styles.dropdown;
        var dropdownCls = isOpen ? [dropdownClsPicker, styles.comboboxOpen].join(' ') : dropdownClsPicker;
        var selectionCls = isOpen ? [styles.selection, styles.comboboxOpen].join(' ') : styles.selection;
        var selectedValueCls = styles.selectedValue;
        var noDataFound = false;
        if (choices && choices.length === 0 && this.props.data.noSuggestionData) {
            choices = [this.props.data.noSuggestionData];
            noDataFound = true;
        }
        this.options = choices.map(function (choice, index) { return (React.createElement(ComboOption_1.default, { testId: utils_1.default(_this.props.testId, 'Option'), key: choice.value, data: { choice: choice, isSelected: _this.state.currentValue && _this.state.currentValue.value === choice.value,
                textData: _this.state.currentText || '' }, onSelect: noDataFound ? _this.onNoSuggestionSelect : _this.onSelect, options: { heighlightTextData: noDataFound || _this.props.options.skipHighlightFeature ? false : true, isRedesign: _this.props.options && _this.props.options.isRedesign }, handelKeyDown: _this.handleKeyDown })); });
        var ulHeight = {};
        if (this.props.options && this.props.options.optionMaxHeight) {
            ulHeight = {
                'max-height': this.props.options.optionMaxHeight,
            };
        }
        var textFeildData = {
            input: this.state.currentText || '',
            name: this.props.data.name,
            placeHolder: this.props.data.placeHolder,
        };
        var texFieldEvents = {
            onBlur: this.onBlur,
            onClear: this.onClear,
            onKeyUp: this.onKeyUp,
        };
        var textFieldOption = {
            autocompleteOption: (this.props.options && this.props.options.autocompleteOption) ? this.props.options.autocompleteOption : 'on',
            disabled: this.props.options && this.props.options.disabled ? this.props.options.disabled : false,
            isRedesign: isRedesign,
            isRennyStyle: isRennyStyle,
            maxLength: this.props.options && this.props.options.maxLength ? this.props.options.maxLength : 50,
            type: TextFieldProps_1.TextFieldType.TEXT,
            accessibility: this.props.options && this.props.options.accessibility ? this.props.options.accessibility : '',
        };
        var displayArrow = this.props.options && this.props.options.displayArrow;
        return (React.createElement("div", { "data-test-id": this.props.testId, className: wrapperCls },
            labelProp && React.createElement("label", { className: styles.comboboxLabel }, labelProp),
            React.createElement("div", { className: containerCls },
                React.createElement("div", { onClick: this.props.options && this.props.options.disabled ? undefined : this.onClick },
                    React.createElement(TextField_1.default, { events: texFieldEvents, data: textFeildData, options: textFieldOption, spi: this.props.spi }),
                    isRedesign && displayArrow &&
                        React.createElement("button", { "aria-label": 'Expand ' + this.props.data.name, className: [styles.arrow, icons.attIcon, icons.attIconArrowDownLight].join(' '), onClick: this.handleArrowBtnClick })),
                React.createElement("div", { className: dropdownCls },
                    React.createElement("ul", { role: "menu", "aria-activedescendant": "true", style: ulHeight }, this.options)))));
    };
    ComboBox.prototype.filterAndSetData = function (txtValue, isOpenVal) {
        var filteredData = this.props.data.choices;
        if (this.props.options && this.props.options.dataSearch) {
            if (txtValue) {
                if (this.props.options && this.props.options.matchCase) {
                    filteredData = this.props.data.choices.filter(function (choice) { return choice.displayText.indexOf(txtValue) !== -1; });
                }
                else {
                    filteredData = this.props.data.choices.filter(function (choice) {
                        return choice.displayText.toUpperCase().indexOf(txtValue.toUpperCase()) !== -1;
                    });
                }
            }
            this.setState({ currentText: txtValue, isOpen: isOpenVal, currentData: { choices: filteredData } });
        }
        else if (!this.props.options.dataSearch) {
            this.setState({ currentText: txtValue, isOpen: isOpenVal, currentData: { choices: filteredData } });
        }
    };
    ComboBox.defaultProps = {
        options: {
            autocompleteOption: 'on',
            className: '',
            dataSearch: true,
            label: '',
        },
        spi: false,
    };
    return ComboBox;
}(React.Component));
exports.default = ComboBox;
//# sourceMappingURL=ComboBox.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ComboBox/ComboBox.js
// module id = 1120
// module chunks = 8